export default {"src":"/_next/static/media/Meta_lockup_positive primary_RGB 1.558a98a2.svg","height":24,"width":109,"blurWidth":0,"blurHeight":0};